import { render, staticRenderFns } from "./qschart.vue?vue&type=template&id=358b164c&scoped=true&"
import script from "./qschart.vue?vue&type=script&lang=js&"
export * from "./qschart.vue?vue&type=script&lang=js&"
import style0 from "./qschart.vue?vue&type=style&index=0&id=358b164c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358b164c",
  null
  
)

export default component.exports